import * as commonStyles from '../common/common.css';
import { sprinkles } from './sprinkles.css';
export const atoms = ({ reset, ...rest }) => {
    if (!reset) {
        return sprinkles(rest);
    }
    const elementReset = commonStyles.resetElement[reset];
    const sprinklesClasses = sprinkles(rest);
    return `${elementReset ? ` ${elementReset}` : ''}${sprinklesClasses ? ` ${sprinklesClasses}` : ''}`;
};
